import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'wholeSalePlanned': [],
  'loading': false,
};

export const wholeSalePlanned = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WHOLE_SALE_PLANNED]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WHOLE_SALE_PLANNED]: (state, action) => ({
      ...state,
      'loading': false,
      'wholeSalePlanned': action.response.data,
    }),
    [ActionTypes.FETCHED_WHOLE_SALE_PLANNED_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'wholeSalePlanned': [],
    }),
   
  })(state, action);
};
